import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, CheckIcon, InfoIcon } from "lucide-react";
import { PRICING } from "../../data/site";
import { BUILD_INCLUDES, HOSTING_INCLUDES } from "../../data/pricing";
import { CtaLink } from "../ui/CtaLink";
import { Reveal } from "../ui/Reveal";
export function PricingCards({
  source
}: {
  source: string;
}) {
  return <div data-id="element-388" data-mp="3e6ym9e4tjohw">
      <div className="grid gap-[clamp(1rem,1.6vw,2rem)] lg:grid-cols-2" data-id="element-389" data-mp="3e6fcikpbo6ey">
        <Reveal className="relative flex flex-col overflow-hidden rounded-[clamp(1.25rem,1.6vw,2rem)] border border-accent/60 bg-ink-2 p-[clamp(1.5rem,3vw,3.5rem)]" data-id="element-390" data-mp="3e8rswtffm8pw">
          <div className="blue-glow pointer-events-none absolute inset-0" aria-hidden data-id="element-391" data-mp="3o4mgm2yiitzj" />
          <div className="relative flex flex-1 flex-col" data-id="element-392" data-mp="3j7ctwv2icwfe">
            <h3 className="t-h3" data-id="element-393" data-mp="1tqtun9z35can">{PRICING.build.name}</h3>
            <p className="mt-2 text-muted" data-id="element-394" data-mp="1trdewxc7kcru">Your complete website, designed and built.</p>
            <p className="mt-8 flex items-baseline gap-3" data-id="element-395" data-mp="1otla52qgsw68">
              <span className="font-display text-[clamp(3.5rem,2.5rem+4vw,8rem)] font-semibold leading-none tracking-tight" data-id="element-396" data-mp="33uszju56lpj">{PRICING.build.price}</span>
              <span className="text-fg-2" data-id="element-397" data-mp="75698yr4lul2">{PRICING.build.cadence}</span>
            </p>
            <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-398" data-mp="c2g9l9g1zqno">
              {BUILD_INCLUDES.map(f => <li key={f} className="flex gap-3 text-fg-2" data-id="element-399" data-mp="gw0xg8nxn495"><CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-soft" aria-hidden data-id="element-400" data-mp="lu2phj3c6dwr" />{f}</li>)}
            </ul>
            <div className="mt-auto pt-10" data-id="element-401" data-mp="qrkrepixrsv9">
              <CtaLink to="/contact" track={`pricing_build_${source}`} size="lg" className="w-full sm:w-auto" data-id="element-402" data-mp="quqi2977r2t3">
                Build My Website <ArrowRightIcon className="h-4 w-4" data-id="element-403" data-mp="zu3r50rfdpda" />
              </CtaLink>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.06} className="flex flex-col rounded-[clamp(1.25rem,1.6vw,2rem)] border border-line bg-ink-2 p-[clamp(1.5rem,3vw,3.5rem)]" data-id="element-404" data-mp="2wn5knang9ep0">
          <h3 className="t-h3" data-id="element-405" data-mp="8qgpj9f5t007">{PRICING.hosting.name}</h3>
          <p className="mt-2 text-muted" data-id="element-406" data-mp="8r05wlp5vgc4">We keep it fast, secure and up to date.</p>
          <p className="mt-8 flex items-baseline gap-3" data-id="element-407" data-mp="3sf2kdem4gjg">
            <span className="font-display text-[clamp(3.5rem,2.5rem+4vw,8rem)] font-semibold leading-none tracking-tight" data-id="element-408" data-mp="hr53630n4yck">{PRICING.hosting.price}</span>
            <span className="text-fg-2" data-id="element-409" data-mp="cqif4k7me2z4">{PRICING.hosting.cadence}</span>
          </p>
          <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-410" data-mp="roavfekzqved">
            {HOSTING_INCLUDES.map(f => <li key={f} className="flex gap-3 text-fg-2" data-id="element-411" data-mp="mpgc8bj434tq"><CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-soft" aria-hidden data-id="element-412" data-mp="moeyfzapo48b" />{f}</li>)}
          </ul>
          <div className="mt-auto pt-10" data-id="element-413" data-mp="wfj4uambmgrj">
            <CtaLink to="/contact" variant="ghost" track={`pricing_hosting_${source}`} size="lg" className="w-full sm:w-auto" data-id="element-414" data-mp="wgkoh3hekbkv">
              Add Hosting &amp; Maintenance
            </CtaLink>
          </div>
        </Reveal>
      </div>
      <p className="mt-6 flex items-start gap-3 text-[15px] text-muted" data-id="element-415" data-mp="1p2j3s3vy7gup">
        <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-soft" aria-hidden data-id="element-416" data-mp="1p0g4suctiddu" />
        <span data-id="element-417" data-mp="1u13w7h4ykw8l">
          {PRICING.cancellationNote}{" "}
          <Link to="/cancellation-policy" className="text-fg-2 underline underline-offset-4 hover:text-fg" data-id="element-418" data-mp="1f4uywl4mosyt">Read the Cancellation Policy</Link>.
        </span>
      </p>
    </div>;
}